// extracted by mini-css-extract-plugin
module.exports = {"hidden":"chatTooltip_hidden__NShZh","textEmphasis":"chatTooltip_textEmphasis__TtIRG","tooltipButton":"chatTooltip_tooltipButton__MDB_2","text":"chatTooltip_text__SOmjv"};